<section class="banner">
    <div>
        <div class="width-container">
            <h1>
                <span [innerHtml]="'BANNER.HEAD' | translate"></span>
                <span class="show-desktop" [innerHtml]="'BANNER.HEAD2' | translate"></span>
                <span class="show-mobile" [innerHtml]="'BANNER.HEAD2_MOBILE' | translate"></span>
                <span class="show-desktop" [innerHtml]="'BANNER.HEAD3' | translate"></span>
                <span class="show-mobile" [innerHtml]="'BANNER.HEAD3_MOBILE' | translate"></span>
            </h1>
        </div>
    </div>
</section>